





















































import { Component, Vue } from 'vue-property-decorator';

import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TAcquisition } from '@/plugins/podolib/services/entities/EntityPatients';
import { Severity } from '@sentry/types';
import {
  AnalysisRunningMode,
  AnalysisType,
  AnalysisWalkingMode,
} from '@/components/analysis/steps/type/AnalysisStepType';

interface IHomeRightSidebar extends Vue {
  error: Error | null;
}

@Component<IHomeRightSidebar>({
  async created() {
    try {
      await this.$pdc.doctor!.getLastAcquisitions();
    } catch (e) {
      this.error = e;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Error);
    }
  },
})
export default class HomeRecentAcquisitions extends Vue {
  error!: Error | null;

  get doctor() {
    return this.$pdc.doctor;
  }
  get lastAcquisitions() {
    return this.doctor!.lastAcquisitions.filter((x: any) => x.patient);
  }

  getStyle(analysisType: AnalysisType, analysisMode?: AnalysisRunningMode | AnalysisWalkingMode | null) {
    return analysisType === AnalysisType.Walking
      ? analysisMode && analysisMode === 'research'
        ? { color: '#3F91DF', icon: 'atom--l' }
        : { color: '#3F91DF', icon: 'walking--r' }
      : { color: 'success', icon: 'running--r' };
  }

  goTo(acquisition: TEntity<TAcquisition>) {
    // Analytics
    /*this.$pdc.analytics?.actions.trackSuccess('Home LatestAnalysis Click', {
      patientId: acquisition.patient._id,
      acquisitionId: acquisition._id,
      isDemo: acquisition.patient.demo || false
    });*/

    this.$router.push({
      name: 'patient-result',
      params: { id: acquisition.patient._id, acquisitionId: acquisition._id },
    });
  }
}
